import React, { useState, useEffect, useRef, useCallback } from 'react';
import { useLocation, useHistory, useParams } from 'react-router-dom';
import {
  useCartDispatch,
  useCartState,
} from '../../../components/context/CartContext';
import queryString from 'query-string';
import { omitBy, isEmpty } from 'lodash';
import useFetch from 'use-http';
import Filter from '../../../components/pages/ServicesPage/FilterNew/FilterNew';
import NoResults from '../../../components/shared/NoResults/NoResults';
import _ from 'lodash';
import Modal from '../../../components/shared/Modal';

import WorkplaceServices from '../../../__mock__/WorkplaceServices';
import InlineLoader from '../../../components/shared/InlineLoader/InlineLoader';
import { exponeaCapture } from '../../../components/hooks/exponeaCapture';
import {
  useUserDispatch,
  useUserState,
} from '../../../components/context/UserContext';
import { SpecialistInfoCard } from '@/v2/components/SpecialistInfoCard/SpecialistInfoCard';
import { SpecialistInfoCardWithCalendar } from '@/v2/components/Calendar/SpecialistInfoCardWithCalendar';
import Page from '@/v2/components/Page';
import { CustomPagination } from '@/v2/components/Pagination/CustomPagination';
import {
  Accordion,
  AccordionContent,
  AccordionItem,
  AccordionTrigger,
} from '@/components/ui/accordion';
import ServicesContainer from './Components/ServicesContainer';
import MrtServicesExplanation from './Components/MrtServicesExplanation';
import { useCartData } from '../CartPage/context/CartDataContext';
import { ShoppingCartIcon } from 'lucide-react';
import { Button } from '@/components/ui/button';
import { useRegistration } from '../CartPage/context/RegistrationContext';
import KtServicesExplanation from './Components/KtServicesExplanation';
const USE_MOCKS = false;

const ServicesPage = (props) => {
  const [page, setPage] = useState(1); // INitial page number
  const [pageSize, setPageSize] = useState(6); // Items per page
  const [pageCount, setPageCount] = useState(6); // Items per page
  const HierarchyLevel = 2; // Make this generic from frontend side if other services needs to be grouped by different levels.
  const { id, categoryId } = useParams();
  const sessionDispatch = useUserDispatch();
  const userState = useUserState();
  const { search: urlParams, state } = useLocation();
  const options = queryString.parse(urlParams);
  const [cityId, setCityId] = useState(null);
  const dispatch = useCartDispatch();
  const [orderedServiceGroups, setOrderedServiceGroups] = useState();
  const [filteredBySpecialty, setFilteredBySpecialty] = useState(false);
  const [selectedDepartmentFilter, setSelectedDepartmentFilter] = useState();
  const [
    laboratoryMultipleServicePayload,
    setLaboratoryMultipleServicePayload,
  ] = useState();
  const [laboratoryBackData, setLaboratoryBackData] = useState();
  const [isLaboratoryMultipleServices, setIsLaboratoryMultipleServices] =
    useState(false);

  const { request: timeRequest, response: timeResponse } =
    useFetch(`/TimeSlots`);

  const history = useHistory();
  const {
    loading: loadingFilters,
    error,
    data: rawFilters = [],
  } = useFetch(
    `/Services/SearchCriterias?categoryId=${categoryId}&serviceTypeId=${id}&workplaceId=${options.workplaceId}` +
      (history.location?.state?.isPaidLaboratoryService === false
        ? `&visitPaymentTypeId=${2}`
        : '') +
      history.location.search.replace('?', '&'),
    [history.location.search],
  );

  const filters = React.useMemo(() => {
    if (!rawFilters || typeof rawFilters !== 'object') return [];

    // Get keys except "visitPaymentType"
    const keysToCheck = Object.keys(rawFilters).filter(
      (key) => key !== 'visitPaymentType',
    );

    // Check if all are empty arrays
    const allEmpty = keysToCheck.every(
      (key) => Array.isArray(rawFilters[key]) && rawFilters[key].length === 0,
    );
    return allEmpty ? [] : rawFilters;
  }, [rawFilters]);

  const externalFamilyDoctorOtherCardInfoId =
    process.env.REACT_APP_SGKN_SERVICE_TYPE_EXT_ID;

  const externalServiceTypeIdForGroupedService =
    process.env.REACT_APP_LABEXTERNALID;

  const secondaryExternalServiceTypeIdForGroupedService =
    process.env.REACT_APP_KTHERAPYEXTERNALID;

  const bySecondHierarchyLevelServiceTypeId =
    process.env.REACT_APP_VACCINEEXTERNALID;

  const esteticLaserServicesExternalServiceTypeId =
    process.env.REACT_APP_ESTETIC_LASER_SERVICE_TYPE_ID;

  const holterExternalServiceTypeId = process.env.REACT_APP_HOLTER;

  const gskServiceTypeId = process.env.REACT_APP_GSK_SERVICE_TYPE_EXT_ID;

  const vgskServiceTypeId = process.env.REACT_APP_VGSK_SERVICE_TYPE_EXT_ID;

  const kMRServiceTypeExternalId =
    process.env
      .REACT_APP_KINESITHERAPY_MASSAGES_REFLEXOTHERAPY_SERVICE_TYPE_EXTERNAL_ID;

  const kinesitherapyServiceGroupExternalId =
    process.env.REACT_APP_KINESITHERAPY_SERVICE_GROUP_EXTERNAL_ID;

  const mRTServiceTypeExternalId =
    process.env.REACT_APP_MRT_SERVICE_TYPE_EXT_ID;

  const kTServiceTypeExternalId = process.env.REACT_APP_KT_SERVICE_TYPE_EXT_ID;

  const [initialFilters, setInitialFilters] = useState(filters);

  const { get, loading: loadingServices } = useFetch(
    '/Services/WorkplaceServicesPaged',
  );

  const { request: serviceRequest, response: serviceGetResponse } =
    useFetch('/Services');

  const { get: getServiceGroups, loading: getServiceGroupsLoading } = useFetch(
    '/Services/ServiceGroups',
  );

  const { get: getServiceHierarchies, loading: getServiceHierarchiesLoading } =
    useFetch('/Services/ServiceHierarchies');

  const {
    get: getServiceTypeExternalId,
    loading: getServiceTypeExternalIdLoading,
  } = useFetch('/Services/ServiceTypeExternalId');

  const {
    post: cancelRegistrationRequestSend,
    response: cancelRegistrationResponse,
  } = useFetch(`/RegistrationManagement/Registrations/Cancel`);

  const [data, setData] = useState({});
  const [arrangement, setArrangement] = useState('Default');
  const [loading, setLoading] = useState(true);
  const cartState = useCartState();
  const isLoading = [loadingFilters, loading].find((l) => l);
  const [moreLoading, setMoreLoading] = useState(false);
  const [filtersAdded, setFiltersAdded] = useState(false);
  const [isActive, setIsActive] = useState();
  const [serviceGroups, setServiceGroups] = useState();
  const [externalServiceTypeId, setExternalServiceTypeId] = useState();
  const [selectedServiceGroup, setSelectedServiceGroup] = useState(undefined);
  const [serviceGroupedServices, setServiceGroupedServices] = useState();
  const [loadingGroup, setLoadingGroup] = useState(false);
  const [expandSingleGroup, setExpandSingleGroup] = useState();
  const [resetGroups, setResetGroups] = useState(false);
  const [serviceTitle, setServiceTitle] = useState('');
  const [isCancelModalVisible, setIsCancelModalVisible] = useState(false);
  const [isCancelRegistration, setIsCancelRegistration] = useState(false);
  const [serviceGroupsLoading, setServiceGroupsLoading] = useState(true);
  const [visitPaymentTypeFilter, setVisitPaymentTypeFilter] = useState(
    options.visitPaymentTypeId,
  );
  const [isPaidLaboratoryService, setIsPaidLaboratoryService] = useState(false);
  const location = useLocation();
  const { setUserInfo, setConsultationInfo, setPaymentInfo } =
    useRegistration();
  const { setComplex, addingMoreServices, services, selectedTimeSlot } =
    useCartData();

  useEffect(() => {
    setUserInfo(null);
    setConsultationInfo(null);
    setPaymentInfo(null);
    sessionDispatch({
      type: 'SET_VISIT_PAYMENT_TYPE',
      visitPaymentType: undefined,
    });
  }, []);

  useEffect(() => {
    if (serviceTitle) {
      exponeaCapture(
        [
          { name: 'category_1', value: serviceTitle },
          { name: 'category_id', value: categoryId },
        ],
        'view_item',
      );
    }
  }, [serviceTitle]);

  // useEffect(() => {
  //   setInitialFilters(filters);
  // }, [filters]);

  function changeActiveState(idx) {
    setIsActive((state) => [...state]);
  }
  function isGroupedServiceType(id) {
    if (
      id != secondaryExternalServiceTypeIdForGroupedService &&
      id != bySecondHierarchyLevelServiceTypeId &&
      id != gskServiceTypeId &&
      id != vgskServiceTypeId &&
      id != esteticLaserServicesExternalServiceTypeId &&
      id != externalServiceTypeIdForGroupedService
    ) {
      return false;
    }
    return true;
  }

  function GroupByHierarchies(id) {
    if (
      id != bySecondHierarchyLevelServiceTypeId &&
      id != gskServiceTypeId &&
      id != externalServiceTypeIdForGroupedService
    ) {
      return false;
    }
    return true;
  }

  useEffect(() => {
    if (history.location?.state?.laboratoryMultipleServices?.length > 0) {
      setIsLaboratoryMultipleServices(true);
      setLaboratoryMultipleServicePayload(history.location?.state);
      setIsPaidLaboratoryService(
        history.location?.state?.isPaidLaboratoryService,
      );
      setLaboratoryBackData({
        lastStep: 1,
        registrationServices: [history.location?.state.values],
        resetStorage: false,
        laboratoryMultipleServices:
          history.location?.state.laboratoryMultipleServices,
      });
    }
  }, [history]);

  // useEffect(() => {
  //   let activeGroupId;
  //   if (!!isActive && isActive.length > 0) {
  //     activeGroupId = isActive.find((x) => x.isActive)?.externalId;
  //   }

  //   if (!!activeGroupId) {
  //     sessionDispatch({
  //       type: 'SET_LAST_ACTIVE_GROUP',
  //       lastActiveGroupId: activeGroupId,
  //     });
  //   }
  // }, [selectedServiceGroup]);

  useEffect(() => {
    if (cartState.leftToPaysera) {
      setIsCancelModalVisible(true);
    }
  }, [cartState.leftToPaysera]);

  useEffect(() => {
    const cancelRegistration = async () => {
      if (isCancelRegistration) {
        await cancelRegistrationRequestSend('', {
          cancelationToken: cartState.registrationId,
        });
        dispatch({
          type: 'RESET_ONLY_REGISTRATION_ID',
        });
        history.push('/payment/error');
      }
    };

    cancelRegistration();
  }, [isCancelRegistration, cartState.registrationId, dispatch, history]);

  function getServicesByGroup(serviceGroupId) {
    let parsedGroupId = JSON.parse(serviceGroupId);

    if (!GroupByHierarchies(externalServiceTypeId)) {
      if (serviceGroupedServices) {
        return serviceGroupedServices.filter(
          (x) => x.serviceGroupId === parsedGroupId,
        );
      } else return [];
    } else {
      if (serviceGroupedServices) {
        return serviceGroupedServices.filter((x) =>
          parsedGroupId === 2147483647
            ? x.secondLevelHierarchyId == null
            : x.secondLevelHierarchyId === parsedGroupId,
        );
      } else return [];
    }
  }

  // eslint-disable-next-line react-hooks/exhaustive-deps
  useEffect(() => {
    const fetchData = async () => {
      if (!id) {
        //trying to prevent /Services/ServiceTypeExternalId with undefined param exception, since id should always be present.
        return;
      }

      if (USE_MOCKS) {
        setData(WorkplaceServices);
        return;
      }
      if (
        !selectedServiceGroup &&
        isGroupedServiceType(externalServiceTypeId)
      ) {
        return;
      }

      const serviceType = await getServiceTypeExternalId(
        `?serviceTypeId=${id}`,
      );

      setExternalServiceTypeId(serviceType?.id);
      setServiceTitle(serviceType?.title);

      const queryParams = queryString.stringify({
        ...queryString.parse(history.location.search),
      });

      if (!isGroupedServiceType(serviceType?.id) && !shouldSelectFilter()) {
        setLoading(true);
        get(
          '?' +
            queryString.stringify({
              ...queryString.parse(history.location.search),
              serviceTypeId: id,
            }) +
            `&workplaceId=${options.workplaceId}&page=${page}&pageSize=${pageSize}`,
        ).then((data) => {
          setData(data);
          setPageCount(data?.pageCount);
          setLoading(false);
        });
      } else if (
        isGroupedServiceType(serviceType?.id) &&
        !shouldSelectFilter()
      ) {
        setLoadingGroup(true);

        get(
          '?' +
            queryString.stringify({
              ...queryString.parse(history.location.search),
              serviceTypeId: id,
            }) +
            (GroupByHierarchies(externalServiceTypeId)
              ? `&hierarchyId=${selectedServiceGroup}&level=${HierarchyLevel}&page=${page}&pageSize=${pageSize}`
              : `&serviceGroupId=${selectedServiceGroup}&page=${page}&pageSize=${pageSize}`),
        ).then((data) => {
          setServiceGroupedServices(data.services);
          setPageCount(data?.pageCount);

          if (
            history.location.search !== '?' &&
            history.location.search !== ''
          ) {
            // setExpandSingleGroup(data);
          }
          setLoadingGroup(false);
        });
      } else if (
        history.location.search === '?' ||
        history.location.search === ''
      ) {
        setExpandSingleGroup(null);
        setResetGroups(true);
      }
    };

    fetchData();
  }, [
    page,
    pageSize,
    externalServiceTypeIdForGroupedService,
    get,
    getServiceTypeExternalId,
    history.location.search,
    id,
    secondaryExternalServiceTypeIdForGroupedService,
    esteticLaserServicesExternalServiceTypeId,
    selectedServiceGroup,
  ]);

  useEffect(() => {
    if (
      externalServiceTypeId != undefined &&
      externalServiceTypeId != bySecondHierarchyLevelServiceTypeId &&
      externalServiceTypeId != gskServiceTypeId &&
      externalServiceTypeId != externalServiceTypeIdForGroupedService &&
      isGroupedServiceType(externalServiceTypeId)
    ) {
      setServiceGroupsLoading(true);
      // setLoading(true);
      getServiceGroups(
        '?' +
          queryString.stringify({
            ...queryString.parse(history.location.search),
            serviceTypeId: id,
          }) +
          `&workplaceId=${options.workplaceId}`,
      ).then((res) => {
        setServiceGroups(res);
        setLoading(false);
        setServiceGroupsLoading(false);
        setSelectedServiceGroup(null);
        if (res.length == 1) {
          setSelectedServiceGroup(res[0].externalId);
        }
      });
    } else if (
      externalServiceTypeId != undefined &&
      isGroupedServiceType(externalServiceTypeId)
    ) {
      setServiceGroupsLoading(true);
      getServiceHierarchies(
        '?' +
          queryString.stringify({
            ...queryString.parse(history.location.search),
            serviceTypeId: id,
          }) +
          `&level=2`,
      ).then((res) => {
        setServiceGroups(res);
        setLoading(false);
        setServiceGroupsLoading(false);
        setSelectedServiceGroup(null);
        if (res.length == 1) {
          setSelectedServiceGroup(res[0].externalId);
        }
      });
    }
  }, [
    bySecondHierarchyLevelServiceTypeId,
    externalServiceTypeId,
    getServiceGroups,
    getServiceHierarchies,
    id,
    history.location.search,
    // resetGroups,
  ]);

  useEffect(() => {
    if (externalServiceTypeId == holterExternalServiceTypeId && serviceTitle) {
      history.push('/kompleksines-paslaugos?holter=true', {
        services: 'holter',
        serviceTitle: serviceTitle,
      });
    }
  }, [externalServiceTypeId, serviceTitle]);

  // useEffect(() => {
  //   if (
  //     selectedServiceGroup !== undefined &&
  //     (history.location.search === '?' || history.location.search === '') &&
  //     !shouldSelectFilter()
  //   ) {
  //     setLoadingGroup(true);

  //     get(
  //       '?' +
  //         queryString.stringify({
  //           ...queryString.parse(history.location.search),
  //           serviceTypeId: id,
  //         }) +
  //         (GroupByHierarchies(externalServiceTypeId)
  //           ? `&hierarchyId=${selectedServiceGroup}&level=${HierarchyLevel}&page=${page}&pageSize=${pageSize}`
  //           : `&serviceGroupId=${selectedServiceGroup}&page=${page}&pageSize=${pageSize}`),
  //     ).then((data) => {
  //       setServiceGroupedServices(data.services);
  //       setPageCount(data.pageCount);
  //       // setData(data);
  //       setLoadingGroup(false);
  //     });
  //   }
  // }, [get, id, selectedServiceGroup, page, pageSize]);

  useEffect(() => {
    if (filters.length === 0) return;

    if (queryString.parse(history.location.search)?.specialtyId !== undefined) {
      setFilteredBySpecialty(true);
    }

    if (
      queryString.parse(history.location.search)?.departmentId !== undefined
    ) {
      setSelectedDepartmentFilter(
        queryString.parse(history.location.search)?.departmentId,
      );
    }

    setFiltersAdded(true);
    setInitialFilters(filters);
  }, [filters, history.location.search]);

  function updateFilters({ value, name }) {
    // if (name === 'isPsdfId') {
    //   setPaymentTypeFilter(value);
    // }

    if (selectedTimeSlot && !selectedTimeSlot.isPaid) {
      setVisitPaymentTypeFilter(selectedTimeSlot?.isPaid ? '2' : null);
    }

    if (name === 'visitPaymentTypeId') {
      setVisitPaymentTypeFilter(value);
    }
    if (name === 'specialtyId' && value != '') {
      setFilteredBySpecialty(true);
    } else if (name === 'specialtyId' && value == '') {
      setFilteredBySpecialty(false);
    }
    setSelectedServiceGroup(undefined);

    if (name === 'departmentId' && value) {
      setSelectedDepartmentFilter(value);
    } else if (name === 'departmentId' && !value) {
      setSelectedDepartmentFilter(undefined);
    }

    if (name === 'cityId' && value) {
      setCityId(value);
    } else if (name === 'cityId' && !value) {
      setCityId(undefined);
    }

    const q = queryString.stringify(
      omitBy({ ...options, [name]: value }, isEmpty),
    );

    sessionDispatch({
      type: 'SET_LAST_ACTIVE_GROUP',
      lastActiveGroupId: undefined,
    });

    history.push({ search: `?${q}` });
  }

  function formatPriceRange(prices = []) {
    const numericPrices = prices
      .map((p) => p.price)
      .filter((p) => typeof p === 'number');

    if (numericPrices.length === 0) return 'N/A';

    const min = Math.min(...numericPrices);
    const max = Math.max(...numericPrices);
    // Only show one price if all values are the same
    return min === max ? `${min} €` : `${min} € – ${max} €`;
  }

  function getTitle() {
    return serviceTitle;
  }

  function clearCart() {
    dispatch({
      type: 'REMOVE LEFTTOPAYSERA',
    });
  }

  function addToMultipleLaboratoryServicesCallback(newSelectedService) {
    serviceRequest
      .get(
        `WorkplaceServices/${newSelectedService.workplaceId}/${newSelectedService.serviceId}`,
      )
      .then((response) => {
        let multipleServices =
          laboratoryMultipleServicePayload.laboratoryMultipleServices;
        response = {
          ...response,
          isPaidLaboratoryService: isPaidLaboratoryService,
        };
        if (
          !multipleServices.some(
            (service) => service.serviceId === response.serviceId,
          )
        ) {
          multipleServices = [...multipleServices, response];
        }

        history.push(laboratoryMultipleServicePayload.backUrl, {
          lastStep: 1,
          registrationServices: [laboratoryMultipleServicePayload.values],
          resetStorage: false,
          laboratoryMultipleServices: multipleServices,
        });
      });
  }

  function getCombinedServicesOfSimpleAndComplex() {
    const combinedServices = [];

    if (data.complexServices && data.complexServices.length > 0) {
      combinedServices.push(
        ...data.complexServices.map((service) => ({
          source: 'complex',
          data: service,
        })),
      );
    }

    if (data?.services) {
      combinedServices.push(
        ...data.services
          .filter(
            (x) =>
              (visitPaymentTypeFilter === 2 && x.nearestPsdfDate !== null) ||
              visitPaymentTypeFilter !== 2,
          )
          .map((service) => ({ source: 'default', data: service })),
      );
    }

    // Sort the combined array alphabetically by title
    const sortedServices = combinedServices.sort((a, b) => {
      let titleA, titleB;

      if (a.source === 'complex') {
        titleA = a.data.service.title;
      } else {
        titleA = a.data.serviceTitle;
      }

      if (b.source === 'complex') {
        titleB = b.data.service.title;
      } else {
        titleB = b.data.serviceTitle;
      }

      // Convert to uppercase for case-insensitive sorting
      const titleAUpper = titleA.toUpperCase();
      const titleBUpper = titleB.toUpperCase();

      return titleAUpper.localeCompare(titleBUpper);
    });
    return sortedServices;
  }

  const getTimeSlots = useCallback(
    (from, to, filter, workplaceId, serviceId) => {
      return timeRequest.get(
        `?WorkplaceId=${workplaceId}&DateFrom=${from}&DateTo=${to}&Filter=${filter}&serviceId=${serviceId}`,
      );
    },
    [timeRequest],
  );

  const isMrtOrKt = () => {
    var isMrtOrKt =
      !!externalServiceTypeId &&
      (externalServiceTypeId == kTServiceTypeExternalId ||
        externalServiceTypeId == mRTServiceTypeExternalId);
    return isMrtOrKt;
  };

  const shouldSelectFilter = () => {
    var isOptions = !!options && Object.keys(options).length > 0;

    return isMrtOrKt() && !isOptions;
  };

  useEffect(() => {
    //trying to prevent old record flickering.
    const isData = !!data && Object.keys(data).length > 0;
    if (shouldSelectFilter() && !!isData) setData({});
  }, [data]);

  return (
    <Page
      error={(!data && !serviceGroups && !loadingFilters) || error}
      loading={false}
    >
      <ServicesContainer marginTop={true}>
        {isLaboratoryMultipleServices && (
          <Page.Title
            backUrl={laboratoryMultipleServicePayload.backUrl}
            backData={laboratoryBackData}
            greyTheme={true}
            smallHeight={true}
          >
            {' '}
            {getTitle()}
          </Page.Title>
        )}
        {!isLaboratoryMultipleServices && (
          <Page.Title backUrl={`/`} greyTheme={true} smallHeight={true}>
            {' '}
            {getTitle()}
          </Page.Title>
        )}
      </ServicesContainer>
      <Filter
        key={externalServiceTypeId}
        value={options}
        onChange={updateFilters}
        isLoading={loadingFilters}
        filters={initialFilters}
        shouldFilterBeExpanded={isMrtOrKt()}
        onClear={() => {
          sessionDispatch({
            type: 'SET_LAST_ACTIVE_GROUP',
            lastActiveGroupId: undefined,
          });

          setCityId(null);
          setLoading(true);
          history.push(history.pathname, {
            search:
              isLaboratoryMultipleServices && options.workplaceId
                ? `?workplaceId=${options.workplaceId}` +
                  (isPaidLaboratoryService === false
                    ? `&visitPaymentTypeId=${2}`
                    : '')
                : '',
          });

          window.location.reload();
        }}
        category={categoryId}
        // sortData={sortData}
        isGrid={categoryId === '1'}
        enableSorting={true}
        disabledFiltersById={
          isLaboratoryMultipleServices && isPaidLaboratoryService === false
            ? ['visitPaymentTypeId']
            : []
        }
      />

      <ServicesContainer style="bg-white">
        {(!isGroupedServiceType(externalServiceTypeId) && loading) ||
        (isGroupedServiceType(externalServiceTypeId) &&
          (loading || serviceGroupsLoading)) ? (
          <div className="relative h-[400px]">
            {<InlineLoader light={true} />}
          </div>
        ) : (
          <>
            <div>
              {addingMoreServices && (
                <div className="bg-[#1F4B81] text-white p-3 rounded-md flex items-center">
                  <div className="flex items-center gap-2">
                    <ShoppingCartIcon className="w-6 h-6" />
                    <span>
                      <strong>
                        Šiuo metu krepšelyje ({services?.length}) tyrimas.
                      </strong>{' '}
                      Pasirinkite papildomus tyrimus naudodami filtrus arba
                      tęskite registraciją
                    </span>
                  </div>
                  <Button
                    className="ml-4 bg-affidea-green hover:bg-affidea-green-hover text-white px-6 py-2 font-medium rounded-4xl transition"
                    onClick={() => history.push('/cart')}
                  >
                    Registruotis ({services?.length})
                  </Button>
                </div>
              )}

              {serviceGroups &&
              serviceGroups.length > 0 &&
              isGroupedServiceType(externalServiceTypeId) ? (
                <div className="mt-3">
                  <Accordion
                    type="single"
                    collapsible
                    value={selectedServiceGroup}
                    onValueChange={(value) => {
                      setSelectedServiceGroup(value ?? null);
                      setPage(1);
                    }}
                    className="mt-3"
                  >
                    {serviceGroups.map(({ externalId, name }) => (
                      <AccordionItem key={externalId} value={externalId}>
                        <AccordionTrigger>{name}</AccordionTrigger>
                        <AccordionContent>
                          {selectedServiceGroup === externalId ? (
                            loadingGroup ? (
                              <InlineLoader light={true} />
                            ) : (
                              <>
                                {getServicesByGroup(externalId)?.map(
                                  (service, i) => (
                                    <SpecialistInfoCardWithCalendar
                                      key={i}
                                      service={service}
                                      visitPaymentTypeFilter={
                                        visitPaymentTypeFilter
                                      }
                                      urlParams={urlParams}
                                      selectedDepartmentFilter={
                                        selectedDepartmentFilter
                                      }
                                      laboratoryMultipleServicePayload={
                                        laboratoryMultipleServicePayload
                                      }
                                      isLaboratoryMultipleServices={
                                        isLaboratoryMultipleServices
                                      }
                                      addToMultipleLaboratoryServicesCallback={
                                        addToMultipleLaboratoryServicesCallback
                                      }
                                      getTimeSlots={getTimeSlots}
                                    />
                                  ),
                                )}
                                <CustomPagination
                                  page={page}
                                  setPage={setPage}
                                  pageCount={pageCount}
                                />
                              </>
                            )
                          ) : null}
                        </AccordionContent>
                      </AccordionItem>
                    ))}
                  </Accordion>
                </div>
              ) : (
                <></>
                // <NoResults>Paieškos rezultatų nėra</NoResults>
              )}

              {!isGroupedServiceType(externalServiceTypeId) &&
                ((data?.services?.length || data?.complexServices?.length) &&
                !shouldSelectFilter() ? (
                  <>
                    <div className="grid grid-cols-1 lg:grid-cols-2 gap-6 justify-items-center mt-2">
                      {data.complexServices &&
                        data.complexServices.length > 0 &&
                        _.orderBy(data.complexServices).map((service, i) => {
                          return (
                            <SpecialistInfoCard
                              key={i}
                              visitPaymentType={visitPaymentTypeFilter}
                              name={service.service.title}
                              specialty={'Paslaugų paketai'}
                              complex={true}
                              infoItems={[
                                {
                                  label: 'Galima PSDF kompensacija',
                                  value: 'Ne',
                                  align: 'left',
                                },
                                {
                                  label: 'Kaina',
                                  value: formatPriceRange(service.prices),
                                  align: 'right',
                                },
                              ]}
                              categoryId={3}
                              onSelect={() => {
                                setComplex(service);
                                history.push('/kompleksines-paslaugos/cart');
                              }}
                            />
                          );
                        })}
                    </div>

                    {data?.services.map((service, i) => {
                      return (
                        <SpecialistInfoCardWithCalendar
                          key={i}
                          service={service}
                          visitPaymentTypeFilter={visitPaymentTypeFilter}
                          urlParams={urlParams}
                          selectedDepartmentFilter={selectedDepartmentFilter}
                          laboratoryMultipleServicePayload={
                            laboratoryMultipleServicePayload
                          }
                          isLaboratoryMultipleServices={
                            isLaboratoryMultipleServices
                          }
                          addToMultipleLaboratoryServicesCallback={
                            addToMultipleLaboratoryServicesCallback
                          }
                          getTimeSlots={getTimeSlots}
                        />
                      );
                    })}

                    {arrangement === 'Service' &&
                      getCombinedServicesOfSimpleAndComplex().map((item, i) => {
                        const { source, data } = item;
                        // return (
                        //   <SpecialistInfoCardWithCalendar
                        //     visitPaymentType={visitPaymentTypeFilter}
                        //     key={i}
                        //     service={source === 'complex' ? data.service : data} // Depending on the source
                        //     categoryId={source === 'complex' ? 3 : categoryId} // Depending on the source
                        //     serviceTypeId={
                        //       source === 'complex' ? undefined : id
                        //     } // Depending on the source
                        //     backUrl={urlParams}
                        //     noRegistrationService={
                        //       source === 'complex'
                        //         ? false
                        //         : externalFamilyDoctorOtherCardInfoId ===
                        //           externalServiceTypeId
                        //     } // Depending on the source
                        //     complexPrices={
                        //       source === 'complex' ? data.prices : undefined
                        //     } // Depending on the source
                        //     selectedFilterDepartment={selectedDepartmentFilter}
                        //     isComplex={source === 'complex'} // Depending on the source
                        //   />
                        // );
                      })}
                    <CustomPagination
                      page={page}
                      setPage={setPage}
                      pageCount={pageCount}
                    />
                  </>
                ) : (
                  <div>
                    {!loading &&
                      ((externalServiceTypeId == mRTServiceTypeExternalId ||
                        externalServiceTypeId == kTServiceTypeExternalId) &&
                      shouldSelectFilter() &&
                      (data?.services?.length == 0 || !data?.services) ? (
                        externalServiceTypeId == kTServiceTypeExternalId ? (
                          <KtServicesExplanation />
                        ) : (
                          <MrtServicesExplanation />
                        )
                      ) : !shouldSelectFilter() &&
                        (data?.services?.length == 0 || !data?.services) ? (
                        <NoResults>Paieškos rezultatų nėra</NoResults>
                      ) : (
                        <NoResults>Pasirinkite filtrą</NoResults>
                      ))}
                  </div>
                ))}

              {moreLoading && (
                <div className="relative h-[400px]">
                  <InlineLoader light={true} />
                </div>
              )}
            </div>
          </>
        )}
      </ServicesContainer>

      <Modal
        visible={cartState.leftToPaysera}
        showClose={false}
        onClose={() => {
          setIsCancelModalVisible(false);
          dispatch({
            type: 'REMOVE_LEFTTOPAYSERA',
          });
          dispatch({
            type: 'RESET_PAYSERA_URL',
          });

          sessionDispatch({
            type: 'SET_LEFT_CART_PAGE',
            left: false,
          });
        }}
      >
        <Modal.TextContent>
          Ar tikrai norite atšaukti registraciją?
        </Modal.TextContent>
        <Modal.Actions>
          <Button
            size="large"
            onClick={() => {
              dispatch({ type: 'SET_LEFTTOPAYSERA' });
              setIsCancelRegistration(false);
              setIsCancelModalVisible(false);
              window.location.replace(cartState.payseraUrl);
            }}
          >
            Grįžti
          </Button>
          <Button
            size="large"
            onClick={() => {
              setIsCancelRegistration(true);
              setIsCancelModalVisible(false);
              dispatch({
                type: 'REMOVE_LEFTTOPAYSERA',
              });
              dispatch({
                type: 'RESET_CART',
              });

              dispatch({
                type: 'RESET_PAYSERA_URL',
              });

              sessionDispatch({
                type: 'SET_LEFT_CART_PAGE',
                left: false,
              });
            }}
          >
            Taip
          </Button>
        </Modal.Actions>
      </Modal>
    </Page>
  );
};

export default ServicesPage;
